import { render, staticRenderFns } from "./LocaisRecebimentoDialog.vue?vue&type=template&id=5f51e74e"
import script from "./LocaisRecebimentoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaisRecebimentoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LocaisRecebimentoDialog.vue?vue&type=style&index=0&id=5f51e74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports